import { default as MuiStepContent } from '@mui/material/StepContent';

/**
 * StepContent wraps the content for a vertical Stepper step.
 *
 * Demos:
 *
 * - [Stepper](https://unify.workiva.org/components/stepper?tab=code)
 *
 * API:
 *
 * - [StepContent API](https://unify.workiva.org/components/stepper?tab=props#stepcontent)
 */
export const StepContent = MuiStepContent;
export {
  type StepContentProps,
  stepContentClasses,
} from '@mui/material/StepContent';
